import React, { useState, useEffect, useContext } from 'react';
import { useQuery, useMutation, useApolloClient } from '@apollo/client';
import { insertActivityLog, getActivityLogQuery } from "../../graphql/activity_log_queries";
import { GlobalContext } from "../../hooks/globalContext";
import apiCall from '../../utility/api';
import { off } from 'process';

type ActivityLogProps = {
    setExportBtnClicked: any;
    pageName: any;
    page: string;
    data: any;
    func: any;
    searchVal: any
    pageNo: any
    setTotalPages: any
    setTotalRecords: any
    isFilter?: any
    dropDownValue1?: any
    setIsFilter?: any
    dropDownValue2?: any
    deleteDevices?: any
    addDevices?: any
    isRefresh?: any,
    setIsRefresh?: any
    setRefreshToast?: any
    type: string;
    moduleName: string;
    setExportDetails: any;
    setRefresh: any;
    filterArray?: any;
    filterMenuOpen?: any;
    setFilterMenuOpen?: any;
}

const Activity_log_func = (props: ActivityLogProps | any) => {
    const client = useApolloClient();
    const contextValue: any = useContext(GlobalContext);
    var tenantName = contextValue.tenantName;
    var userId = contextValue.userSessionDetails.userId.toString();
    var userDetailsFromLocalStorage: any = localStorage.getItem("userDetails");
    var role = contextValue.isRole ? contextValue?.isRole : userDetailsFromLocalStorage?.role_assigned;

    const getActivityLog = async (whereCondition: object, limit: number | null, offset: number | null) => {
        try {
            const { status, data } = await apiCall(`/activity/getList`, { ...whereCondition, limit, offset });

            if (status === 'success' && data?.length > 0) {
                props.func(data);
            } else {
                props.func([]);
            }
        } catch (error) {
            console.log("getActivityLog error=", error);
            props.func([]);
        }
    }

    const getActivityLogCnt = async (whereCondition: object, limit: number | null, offset: number | null) => {
        try {
            const { status, data } = await apiCall(`/activity/getCount`, whereCondition);

            if (status === 'success' && data) {
                props.setTotalRecords(data.totalRecords);
                props.setTotalPages(data.totalPages);
            } else {
                props.setTotalRecords(0);
                props.setTotalPages(1);
            }
        } catch (error) {
            console.log("getActivityLogCnt error=", error);
            props.setTotalRecords(0);
            props.setTotalPages(1);
        }
    }

    const getExportData = async (condition: object) => {
        try {
            const { status, data } = await apiCall(`/activity/getList`, condition);

            if (status === 'success') {
                props.setExportDetails && props.setExportDetails(data);

                props.setExportBtnClicked(false);
            }
        } catch (error) {
            console.log("getExportData error=", error);

            props.setExportBtnClicked(false);
        }
    }

    useEffect(() => {
        if (props.exportBtnClicked) {
            getExportData({ tenant: tenantName, moduleName: props.moduleName, function: 'export' });
        } else if (props.type === 'getLog' || props.isRefresh || props.pageNo > 0) {
            if (role === 'Admin' || role === 'Nanoheal-admin') {
                if (props.pageName === 'administrationAuditLog') {
                    if (props.searchVal?.length > 0) {
                        console.log("Only with admin page and with role")
                        getActivityLog({ function: 'search', moduleName: props.moduleName, search: props.searchVal }, 50, props.pageNo);
                        getActivityLogCnt({ function: 'search', moduleName: props.moduleName, search: props.searchVal }, null, null);
                    } else if (props.isFilter) {
                        console.log("Only with admin page and with role")
                        getActivityLog({ function: 'filter', moduleName: props.moduleName, filter: props.filterArray }, 50, props.pageNo);
                        getActivityLogCnt({ function: 'filter', moduleName: props.moduleName, filter: props.filterArray }, null, null);
                    } else if (props.filterMenuOpen === true) {
                        console.log("calling filter data");
                        getActivityLog({ function: 'filter', moduleName: props.moduleName, filter: props.filterArray }, null, null);
                        getActivityLogCnt({ function: 'filter', moduleName: props.moduleName, filter: props.filterArray }, null, null);
                    } else {
                        console.log("Only with admin page and with role")
                        getActivityLog({ moduleName: props.moduleName }, 50, props.pageNo);
                        getActivityLogCnt({ moduleName: props.moduleName }, null, null);
                    }
                } else if (props.searchVal?.length > 0) {
                    console.log("Only with role")
                    getActivityLog({  function: 'search', moduleName: props.moduleName, search: props.searchVal }, 50, props.pageNo);
                    getActivityLogCnt({  function: 'search', moduleName: props.moduleName, search: props.searchVal }, null, null);
                } else if (props.isFilter) {
                    console.log("Only with role")
                    getActivityLog({  function: 'filter', moduleName: props.moduleName, filter: props.filterArray }, 50, props.pageNo);
                    getActivityLogCnt({  function: 'filter', moduleName: props.moduleName, filter: props.filterArray }, null, null);
                } else if (props.filterMenuOpen === true) {
                    console.log("calling filter data");
                    getActivityLog({ function: 'filter', moduleName: props.moduleName, filter: props.filterArray }, null, null);
                    getActivityLogCnt({ function: 'filter', moduleName: props.moduleName, filter: props.filterArray }, null, null);
                } else {
                    console.log("Only with role")
                    getActivityLog({ moduleName: props.moduleName }, 50, props.pageNo);
                    getActivityLogCnt({ moduleName: props.moduleName }, null, null);
                }
            } else if (props.searchVal?.length > 0) {
                console.log("Only with in the type")
                getActivityLog({ moduleName: props.moduleName, function: 'search', search: props.searchVal }, 50, props.pageNo);
                getActivityLogCnt({ moduleName: props.moduleName, function: 'search', search: props.searchVal }, null, null);
            } else if (props.isFilter) {
                console.log("Only with in the type")
                getActivityLog({ moduleName: props.moduleName, function: 'filter', filter: props.filterArray }, 50, props.pageNo);
                getActivityLogCnt({ moduleName: props.moduleName, function: 'filter', filter: props.filterArray }, null, null);
            } else {
                console.log("Only with in the type")
                getActivityLog({moduleName: props.moduleName }, 50, props.pageNo);
                // getActivityLogCnt({ tenant: tenantName, pageName: props.pageName, moduleName: props.moduleName }, null, null);
                getActivityLogCnt({moduleName: props.moduleName }, null, null);
            }
        }
    }, [props.pageNo, props.searchVal, props.isFilter, props.filterArray, props.filterMenuOpen]);
    
    useEffect(() => {
        if (props.exportBtnClicked) {
            getExportData({ tenant: tenantName, moduleName: props.moduleName, function: 'export' });
        }
        if (props.isRefresh) {
            getActivityLog({moduleName: props.moduleName }, 50, props.pageNo);
            getActivityLogCnt({moduleName: props.moduleName }, null, null);
        }
    }, [props.isRefresh,props.exportBtnClicked])
    
    return (<></>);
}

export { Activity_log_func }